// src/internal/components/navigation/navigation.tsx
import * as React from "react";
import { useLocation, NavLink } from "react-router-dom";
import Tabs from "@mui/material/Tabs";
import { getValidChildren } from "@clara/react-utils";
import { jsx } from "react/jsx-runtime";
var NavigationList = React.forwardRef(
  ({ children, ...rest }, ref) => {
    const location = useLocation();
    const tabs = getValidChildren(children).map((child, index) => {
      const { href = "/#" } = child.props;
      const tab = React.cloneElement(child, {
        component: NavLink,
        label: child.props.children,
        key: `link-${href}-${index}`,
        to: href,
        ...child.props
      });
      return tab;
    });
    const value = Math.max(
      0,
      tabs.findIndex((tab) => tab.props.href === location.pathname)
    );
    return /* @__PURE__ */ jsx(Tabs, { ref, role: "navigation", value, ...rest, children: tabs });
  }
);
NavigationList.displayName = "NavigationList";
var navigation_default = NavigationList;

export {
  navigation_default
};
